module.exports = __webpack_public_path__ + "img/ic_telphone.f9b18867.svg";